import getEnvironDomain from 'ati-utils/getEnvironDomain';

const getBasePath = () => {
  return `${getEnvironDomain()}/timeslots`;
};

export default getBasePath;
